<template>
    <ContentPage title="Pricing - Seller">
        <div>
            <p>
                Unless otherwise agreed in writing or specified in the specific auction terms, the commissions owed by the Seller to Fleequid for the
                sale of each vehicle carried out using the Marketplace or Fleequid's sales services and systems are as follows:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> net of VAT</p>
            <p><strong>**</strong> plus VAT if applicable</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Example 1:</p>
            <p>Clearing Price: €&nbsp;6,000 +&nbsp;VAT</p>
            <p>
                Fee due to Fleequid by the Seller: <br class="md:hidden" />
                <span class="font-medium">
                    €&nbsp;250 +&nbsp;(6,000 * 8.75%) =
                    <span class="whitespace-nowrap">€&nbsp;775 +&nbsp;VAT</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Example 2:</p>
            <p>Clearing Price: €&nbsp;180,000 +&nbsp;VAT</p>
            <p>
                Fee due to Fleequid by the Seller: <br class="md:hidden" />
                <span class="font-medium">
                    €&nbsp;250 +&nbsp;(€&nbsp;100,000 * 8.75%) +&nbsp;(€&nbsp;80,000 * 3.75%) =
                    <span class="whitespace-nowrap">€&nbsp;12,000 +&nbsp;VAT</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
